import * as service from './service'
export default {
  namespace: 'walletTransfer',
  state: {
    demoData: {}
  },
  effects: {
    * aliPayOauthToken ({ payload }, { call, put }) {
      try {
        const res = yield call(service.aliPayOauthToken, payload)
        return res.data
      } catch (error) {
        return Promise.reject()
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
